import { render, staticRenderFns } from "./v-card-group.vue?vue&type=template&id=410facc5&scoped=true&"
import script from "./v-card-group.vue?vue&type=script&lang=js&"
export * from "./v-card-group.vue?vue&type=script&lang=js&"
import style0 from "./v-card-group.vue?vue&type=style&index=0&id=410facc5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410facc5",
  null
  
)

export default component.exports